// import Strings from 'localization/Strings';

export default class StringsBase {
    static get Disclaimer() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get Welcome() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get StatModelMoreInfo() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get MoreInfo() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get General() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get Loss() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get Age() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get Sound() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get Telephone() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get Quiet() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get Effort() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get Summary() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get Searching() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get Results() {throw new Error('Subclasses must implement the pageTitle getter');}
    static get MarketingPanel() {throw new Error('Subclasses must implement the pageTitle getter');}

    static addParams(str) {
        let template = "${}";
        for (var i = 1; i < arguments.length; i++){
            let ind = str.indexOf(template);
            if (ind > -1) {
                str = str.substring(0, ind) + arguments[i] + str.substring(ind + template.length);
            }
        }
        return str;
    }
    static getLossString(jsonLoss) {
        if (!this.Loss || typeof this.Loss !== 'object') return "";
        switch(jsonLoss) {
            case "severe":
                return this.Loss["SeverePlain"];
            case "severe to profound":
                return this.Loss["SevereToProfoundPlain"];
            case "profound":
                return this.Loss["ProfoundPlain"];
            case "very profound":
                return this.Loss["VeryProfoundPlain"];
            default:
                return "";
        }
    }
}
